// Lightweight client-side analytics tracker.
// Fires events to /api/events. Best-effort, never blocks UI.
import { api } from "@/lib/api";

const SID_KEY = "fim_sid";

function sid() {
  let s = sessionStorage.getItem(SID_KEY);
  if (!s) {
    s = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem(SID_KEY, s);
  }
  return s;
}

export function track(type, meta) {
  try {
    api
      .post("/events", {
        type,
        meta: meta || {},
        session_id: sid(),
        path: window.location.pathname + window.location.hash,
      })
      .catch(() => {});
  } catch {
    /* noop */
  }
}

// Auto-instrument clicks on elements with [data-cta]
export function installCtaListener() {
  if (typeof document === "undefined") return;
  const handler = (e) => {
    const el = e.target.closest("[data-cta]");
    if (!el) return;
    track("cta_click", { cta: el.getAttribute("data-cta") });
  };
  document.addEventListener("click", handler, { capture: true });
}
